export { default } from './MapQuickAccessMobileCustom';
